import React, { useEffect, useState } from 'react';
import ProjectCard from './ProjectCard';
import Img1 from '../../images/project-prac.png';
import styled from 'styled-components';
import CardFuzz from './CardFuzz';
import House1 from '../../images/projects/beeston after.jpg';
import House2 from '../../images/projects/bramcote round back.jpg';
import House3 from '../../images/projects/wilford after 1.jpg';
import House4 from '../../images/projects/edingley after.jpg';
import House5 from '../../images/projects/mb-center.png';
import House6 from '../../images/projects/ockbrook after.jpg';
import House7 from '../../images/projects/higgy-house.jpg';
import House8 from '../../images/projects/edwalton.jpg';
import House9 from '../../images/projects/woodborough 5.jpg';
import House10 from '../../images/projects/east bridgeford after.jpg';
import House11 from '../../images/projects/woodborough ext b4.jpg';
import House12 from '../../images/projects/mansion.jpeg';
import ProjectCard2 from './ProjectCard2';
import CardClean from './CardClean';
import './Options.css';
import { useInView } from 'react-intersection-observer';
import CardClean2 from './CardClean2';
import 'aos/dist/aos.css';
import Aos from 'aos';
import {useNavigate} from "react-router-dom";
import {collection, getDocs, orderBy, query} from "firebase/firestore";
import {db} from "../../firebase.config";

const Container = styled.div`
  background: rgb(245, 245, 245);
  width: 100vw;
  height: 100%;
  padding-left: 200px;
  padding-right: 200px;
  overflow: hidden;
  padding-bottom: 50px;
  @media screen and (max-width: 1400px) {
    padding-left: 100px;
    padding-right: 100px;
  }
  @media screen and (max-width: 1000px) {
    padding-left: 50px;
    padding-right: 50px;
  }
  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    display: flex;
    flex-direction: column;
    width: 100vw;
    align-items: center;
    grid-row-gap: 25px;
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0;
  }
  @media screen and (max-width: 500px) {
    height: 100%;
    padding-bottom: 25px;
  }
`;
const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
  height: 100%;
  @media screen and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    display: flex;
    flex-direction: column;
    width: 100vw;
    align-items: center;
    grid-row-gap: 25px;

    margin-left: 0;
  }
`;
const OptionsWrapper = styled.div`
  padding-top: 5vh;
  padding-bottom: 5vh;
  grid-gap: 25px;
  width: 100%;
`;
const Options = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
  @media screen and (max-width: 500px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;
const Option = styled.div`
  font-weight: 500;
  font-size: 1.5rem;
  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
  }
`;
const DashedRow = styled.div`
  grid-column: span 4;
  border-bottom: 1px solid #081542;
  margin-left: 40%;
  margin-right: 40%;
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
  @media screen and (max-width: 1200px) {
    grid-column: span 3;
    display: none;
  }
`;
const CardWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
`;
const LoadingCardWrapper = styled.div`
  width: 300px;
  height: 300px;
  overflow: hidden;
    background: #e0e0e0;

  @media screen and (max-width: 1100px) {
    height: 325px;
    width: 300px;
  }
  @media screen and (max-width: 1000px) {
    width: 350px;
    height: 350px;
  }
  @media screen and (max-width: 900px) {
    height: 300px;
    width: 275px;
  }
  @media screen and (max-width: 800px) {
    height: 350px;
    width: 350px;
  }
  @media screen and (max-width: 700px) {
    height: 275px;
    width: 325px;
  }
  @media screen and (max-width: 500px) {
    height: 300px;
  }
`;

const ProjectCards = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(function() {
    async function fetchProjects() {
      try {
        setLoading(true);
        setError('');
        const projectsRef = collection(db, 'projects');
        const q = query(projectsRef, orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        const projectsList = snapshot.docs.map(function(doc) {
          return {
            id: doc.id,
            ...doc.data()
          };
        });
        setProjects(projectsList);
      } catch (err) {
        console.error('Error fetching projects:', err);
        setError('Failed to load projects. Please try again.');
      } finally {
        setLoading(false);
      }
    }

    fetchProjects();
  }, []);
  
  const [filterCategory, setFilterCategory] = useState('all');
  
  const categories = ['all', 'extension', 'conversion', 'new build', 'landscape'];
  
  const displayProjectTypeMap = {
    all: 'All',
    extension: 'Extension',
    conversion: 'Conversion',
    'new build': 'New Build',
    renovation: 'Renovation',
    landscape: 'Landscape',
  }
  
  const filteredProjects = filterCategory !== 'all' 
    ? projects.filter((project) => project.projectType === filterCategory)
    : projects;
  
  function getMainImageUrl(images) {
    const mainImage = images.find((image) => image.mainImage);
    
    if (mainImage) return mainImage.url;
    
    return [...images].sort(function(a, b) { return a.ordinal - b.ordinal; })[0].url;
  }

  function handleProjectTypeChange(e) {
    setFilterCategory(e.target.value);
  }
  
  const [ref, inView] = useInView();
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <Container>
      <OptionsWrapper>
        <Options>

          <div className={"flex flex-col gap-4 sm:hidden w-[325px]"}>
            <label htmlFor="projectType" className={"text-left"}>Project type:</label>
            <select
              id="projectType"
              value={filterCategory}
              onChange={handleProjectTypeChange}
              className="px-4 w-full py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
            >
              {categories.map(function (type) {
                return (
                  <option key={type} value={type}>
                    {displayProjectTypeMap[type]}
                  </option>
                );
              })}
            </select>
          </div>

          {categories.map((category) => (
            <Option
              key={category}
              className={`hidden sm:block ${filterCategory === category ? 'underline-category' : ''}`}
              onClick={() => setFilterCategory(category)}
            >
              {displayProjectTypeMap[category]}
            </Option>
          ))}

        </Options>
      </OptionsWrapper>

      <CardsWrapper data-aos="fade-up">
        {loading ? (
          <>
            {[...Array(8)].map((_, index) => (
              <LoadingCardWrapper key={index}></LoadingCardWrapper>
            ))}
          </>
        ) : (
          <></>
        )
        }
        {filteredProjects.map((project, index) => (
          <div className={`${filterCategory === 'all' ? 'fade-in' : 'fade-in-2'}`}>
            <CardWrap>
              <CardClean
                id={project.id}
                src={getMainImageUrl(project.images)}
                header={project.header}
                key={index}
                details={displayProjectTypeMap[project.projectType]}
              />
            </CardWrap>
          </div>
        ))}
      </CardsWrapper>
    </Container>
  );
};

export default ProjectCards;
